import API from '../../../../../services/api';

export const TARIFAS_API = {
    get: async () => {
        return await API.get('/tarifas').then(res => res.data);
    },
    new: async (tarifa) => {
        return API.post('/tarifas', tarifa).then(res => res.data);
    },
    update: async (tarifa) => {
        return API.put('/tarifas/' + tarifa.id, tarifa).then(res => res.data);
    },
    delete: async (idTarifa) => {
        return API.delete('/tarifas/' + idTarifa).then(res => res.data);
    }
}